import React from 'react';
import AdminAnalyticsPage from '../Analytics/AdminAnalyticsPage';
const AdminDashboard: React.FC = () => {
  return (
    <div>
      <AdminAnalyticsPage />
    </div>
  );
};

export default AdminDashboard;
